"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFullNameFormat = getFullNameFormat;
function getFullNameFormat(configuration) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- in this case its preffered
  return configuration?.customerConfiguration?.fullNameFormat || '{LastName} {FirstName}';
}